// Mock for react-native-reanimated on web
import { useRef, useEffect } from 'react';

// Mock animated value
export function useSharedValue(initialValue) {
  return { value: initialValue };
}

// Mock animated style
export function useAnimatedStyle(callback) {
  return callback();
}

// Mock animated props
export function useAnimatedProps(callback) {
  return callback();
}

// Mock animation functions
export function withTiming(value, config, callback) {
  callback && callback(true);
  return value;
}

export function withSpring(value, config, callback) {
  callback && callback(true);
  return value;
}

export function withDecay(config, callback) {
  callback && callback(true);
  return 0;
}

export function withRepeat(animation, numberOfReps, reverse, callback) {
  return animation;
}

export function withSequence(...animations) {
  return animations[0];
}

export function withDelay(delayMs, animation) {
  return animation;
}

// Mock gesture handlers
export function useAnimatedGestureHandler(handlers) {
  return handlers;
}

export function useAnimatedScrollHandler(handler) {
  return handler;
}

// Mock animated ref
export function useAnimatedRef() {
  return useRef(null);
}

// Mock runOnJS and runOnUI
export function runOnJS(fn) {
  return fn;
}

export function runOnUI(fn) {
  return fn;
}

// Mock cancelAnimation
export function cancelAnimation(animatedValue) {
  return;
}

// Mock interpolate
export function interpolate(value, inputRange, outputRange, options) {
  return value;
}

// Mock Extrapolate
export const Extrapolate = {
  CLAMP: 'clamp',
  EXTEND: 'extend',
  IDENTITY: 'identity',
};

// Mock Easing
export const Easing = {
  linear: (t) => t,
  ease: (t) => t,
  quad: (t) => t * t,
  cubic: (t) => t * t * t,
  bezier: () => (t) => t,
  in: (easing) => easing,
  out: (easing) => easing,
  inOut: (easing) => easing,
};

// Mock animated components - just return the base component
export default {
  View: 'View',
  Text: 'Text',
  Image: 'Image',
  ScrollView: 'ScrollView',
  FlatList: 'FlatList',
  createAnimatedComponent: (component) => component,
};

// Export everything
export const createAnimatedComponent = (component) => component;

